import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';

import { PartnerInscriptionDraftService } from '../services/partner-inscription-draft.service';

@Injectable({
  providedIn: 'root',
})
export class PartnerInscriptionStepGuard implements CanActivate {
  private readonly stepRoutes = ['step-1', 'step-2', 'step-3'] as const;
  private router = inject(Router);
  private draftService = inject(PartnerInscriptionDraftService);


  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree {
    const requestedStepRoute = route.routeConfig?.path?.split('/').pop();
    if (!requestedStepRoute) {
      return true;
    }

    if (!this.isWizardStepRoute(requestedStepRoute)) {
      return true;
    }
    const requestedWizardStepRoute = requestedStepRoute as 'step-1' | 'step-2' | 'step-3';

    // Navegacao interna legitima (autorizacao de uso unico).
    const authorizedNext = this.draftService.consumeAuthorizedNextWizardStepRoute();
    if (authorizedNext === requestedWizardStepRoute) {
      this.draftService.setCurrentWizardStepRoute(requestedWizardStepRoute);
      return true;
    }

    const currentStepRoute = this.draftService.getCurrentWizardStepRoute();
    if (currentStepRoute) {
      if (currentStepRoute === requestedWizardStepRoute) {
        return true;
      }
      return this.router.parseUrl(`/cadastro-parceiros/inscricao/${currentStepRoute}`);
    }

    // Se vier de fora do fluxo tentando entrar por step direto, volta para o inicio.
    return this.router.parseUrl('/cadastro-parceiros/inscricao/comece-aqui');
  }

  grantStepAccess(stepRoute: string): void {
    if (this.isWizardStepRoute(stepRoute)) {
      this.draftService.authorizeNextWizardStepRoute(stepRoute as 'step-1' | 'step-2' | 'step-3');
    }
  }

  private isWizardStepRoute(stepRoute: string): boolean {
    return this.stepRoutes.some((route) => route === stepRoute);
  }
}

